interface PermutaFlowProps {
    image: string;
    title: string;
    description: string;
    step: number;
}

const PermutaFlow = ({ image, title, description, step }: PermutaFlowProps) => {
    return (
        <div
            className="relative bg-cover bg-center bg-no-repeat text-white min-h-[400px] shadow-lg"
            style={{
                backgroundImage: `url(${image})`,
            }}
        >
            <div className="absolute bottom-0 left-0 right-0 p-8 z-10 flex gap-x-4 items-start bg-gradient-to-t from-black/60 to-transparent ">
                <div
                    className="flex items-center justify-center px-2.5 h-10 bg-gray-300 border border-white rounded-full text-lg font-bold text-black">
                    {step.toString().padStart(2, '0')}
                </div>
                <div className="flex flex-col justify-start items-start">
                    <div className="text-xl font-semibold">{title}</div>
                    <p className="text-sm text-left">{description}</p>
                </div>
            </div>
        </div>
    );
};

export default PermutaFlow;
